<template>
  <div class="container">
    <div class="content-box">
    <div class="nav-bar">
        <div @click="toPage('/index')">首页 > </div><div @click="toPage('/about/company-profile')">关于焱图 > </div><div @click="toPage('/about/company-news')">焱图动态 > </div><div class="blue">{{ content.newsTitle }}</div>
    </div>
    <div class="news-wrap">
      <div class="title">{{ content.newsTitle }}</div>
      <div class="time">{{ content.createTime }}</div>
      <div class="news-content" v-html="content.newsContent"></div>
    </div>
  </div>
</div>
</template>

<script>
import {getNewsDetail} from "../../util/api.js";

export default{
    data() {
      return {
      content:{}
    }
    },
    created() {
      this.getDetail()
    },
    methods:{
        toPage(data){
            this.$router.push(data)
        },
        getDetail() {
          getNewsDetail(this.$route.params.id).then(res => {
        if(res.data.status == "success") {
          this.content = res.data.data
          this.content.createTime = this.formatDate(this.content.createTime)
        }
      })
        },
        formatDate(isoDateString) {
    const date = new Date(isoDateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要 +1
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
},
    }
  }
</script>

<style lang="stylus" scoped>
.container {
    width:100%;
    height:100%;
    .content-box {
      max-width:var(--main-width);
      width:84%;
      margin:0 auto;
    .nav-bar {
        display: flex;
        margin-top:106px;
        color:#999999;
        font-size:0.88rem;
        padding:10px 0;
        div {
          cursor:pointer;
        }
    }
    .news-wrap {
      margin-top:4.3rem;
      .title {
        font-weight: 500;
        font-size: 2rem;
        color: #333333;
      }
      .time {
        margin:1.25rem 0;
        color:#999999;
        padding-bottom:1.25rem;
        border-bottom:1px solid #EBEBEB;
      }
    }
    .news-content {
      display: block;
      width: 100%;
      overflow: hidden;
      padding-bottom: 4rem;
      color: #333;
      font-size: 1rem;
      line-height: 1.8;
      word-break: break-word;

      /deep/ img {
        display: block;
        max-width: 100% !important;
        width: auto !important;
        height: auto !important;
        margin: 1rem auto;
        object-fit: contain;
      }

      /deep/ p {
        margin: 0.75rem 0;
        line-height: 1.8;
      }

      /deep/ video,
      /deep/ iframe {
        max-width: 100%;
      }

      /deep/ table {
        max-width: 100%;
        overflow-x: auto;
        display: block;
      }
    }
    .blue {
      color:#2372E9;
    }
  }
}

@media only screen and (max-width: 768px) {
  .container {
    .content-box {
      width: calc(100% - 30px);

      .nav-bar {
        margin-top: 80px;
        flex-wrap: wrap;
        font-size: 12px;
      }

      .news-wrap {
        margin-top: 1.5rem;

        .title {
          font-size: 1.375rem;
          line-height: 1.4;
        }
      }

      .news-content {
        font-size: 0.9375rem;
        padding-bottom: 2.5rem;

        /deep/ img {
          margin: 0.75rem auto;
        }
      }
    }
  }
}
</style>
